const en = {
    language: "ENGLISH",

    jin10: {
        a1: "Date",
        a2: "Pre",
        a3: "Now",
        a4: "Est",
        a5: "10K"
    },

    

    logReg: {
        a1: "Phone",
        a2: "Password",
        a3: "Verify code",
        a4: "Login",
        a5: "Sign in",

        b1: "Reset Password",
        b2: "New password",
        b3: "Confirm",
        b4: "Phone",
        b5: "Verify code",
        b6: "Receive code",
        b7: "Submit",
        b8: "Clear",

        c1: "Ref code",
        c2: "Email",
        c3: "Password",
        c4: "Confirm",

        d1: "Old password"
    },

    fourReport: {
        flow: "股票资金流向",
        report: "中国CPI月报告",
        daily: "期货仓单日报",
        store: "美国EIA库存",

        a1: "FEDFUNDS",
        a2: "UNRATE",
        a3: "FOREXHEAT",
        a4: "CRYPTOINFO"
    },
    seeMore: "",
    action: "More",
    delFav: "Remove",
    statistical: "Statistic",
    totalMoney: "Amount",
    listNum: "ListNUM",
    submit: "Submit",
    close: "Close",
    moneyTable: {
        name: "Name",
        bank: "Bank Name",
        open_bank: "Bank Address",
        card_code: "Bank Account Number",
        money: "Amount",
        info_d: "TransactionINFO",
        id: "Order ID",
        way_d: "Payment Method",
        status: "Status",
        time: "Time",
        msg: "Comment"
    },
    news: {
        quick: "NEWS",
        calendar: "Calendar",
        rank: "Rank"
    },
    tradeSymbol: {
        stock: "Stocks",
        index: "Indices",
        goods: "Futures",
        options: "Options",
        bitcoin: "Cryptocurrencies",
        money: "Currencies"
    },
    homeTable: {
        updated_datetime: "TIME",
        name: "NAME",
        name_pair: "SYMBOL",
        latest_p: "LAST",
        up_range: "CHG%",

        up_number: "CHG",
        up_number_a: "CHG",

        now_p: "LAST",
        buy_p: "BID",
        sale_p: "ASK",
        buy_v: "BID VOL",
        sale_v: "ASK VOL",
        deal_v: "VOL",
        money: "Volume*Price",
        hold_v: "Open Interest",
        dayRise: "Open Interest CHG",
        open: "OPEN",
        high: "HIGH",
        low: "LOW",
        close: "CLOSE",
        exchange: "EXCHANGE",
        symbol: "SYMBOL",

        contract_intro: "Specification",
        max_volume: "Maximal volume",
        amount_precision: "Volume step",
        sale_datetime: "Trade time",
        contract_size: "Contract Size",
        min_volume: "Minimal volume",
        price_precision: "Digits"
    },
    option: {
        up: "CALL",
        down: "PUT"
    },
    bannerTitle: {
        allStock: "All stocks",
        Subscribed: "Options"
    },
    notice: {
        realAuth: "Real-name authentication Needed",
        realAuth2: "Account need verified before trading. Click to Verify",
        confirm: "Authenticate",
        noFavorite: "Null"
    },
    footer: {
        home: "Home",
        market: "Market",
        optional: "Watchlist",
        news: "News",
        mine: "Account"
    },
    mine: {
        nav: {
            Deal: "Trade",
            CustomerManagement: "Client",
            WithdrawDeposite: "Fund",
            ReportQuery: "Report",
            SystemConfig: "System"
        },

        currentEquity: "Equity",
        balance: "Free margin",
        premium: "Premium",
        positiongl: "Position profit",
        todayDeposit: "Today deposit",
        todayWithdraw: "Today withdraw",

        qrcode: "Account opening QR",
        sideMenu: {
            SettingInOut: "出入金设置",
            Subscribed: "Trade",
            ListClientAdmin: "Client list",
            CustomerAction: "CustomerAction",
            UnnormalMatch: "UnnormalMatch",


            Deposite: "Deposit",
            Withdraw: "Withdraw",
            UnCheckDeposite: "Deposit list",
            UnCheckWithdraw: "Withdraw list",

            DelegateOrder: "Open order",
            RecordPosition: "Position Enquiry",
            RecordTrade: "Trade record",
            RecordStatistics: "Statistical statement",
            BillDetail: "Fund detail",
            RecordCommission: "Commission record",

            SettingRole: "Role",
            SettingGroup: "Group",
            SettingRank: "Commission",
            SettingOrg: "Institution",
            RecordLog: "Log",
            SettingSystem: "Setting",

            SubAccount: "Sub account",
            Profile: "Profile",
            pwdChange: "Password CHG",

            logout: "Logout"
        },
        a1: "Equity",
        a2: "Profit",
        a3: "Balance",
        a4: "Free margin",
        a5: "Margin",
        a6: "Safety"
    },
    Subscribed: {
        search: "Fill in",
        cycle: "Expiry",
        notional: "Notional sum",
        wan: "10K",
        yuan: "$",
        hand: "Size",
        about: "Estimated",
        type: "Type",
        dealway: "Trade mode",
        alwaysNow: "Market price",
        limitPrice: "Limit price",
        premium_ratio: "Premium ratio",
        payPrice: "Amount",
        buy: "Trade",
        setMoney: "Fill in price",
        close: "Close",
        submit: "Submit"
    },
    deposite: {
        a1: "Target amount",

        doDeposite: "Deposit",
        setWay: "Deposit method",
        setWay2: "Withdraw method",
        hint: "Amount",

        wayList: {
            Transfer: "Unionpay",
            Alipay: "Alipay",
            QuFuBao: "Onlinepayment",
            Transfer1: "Unionpay1",
            Bitcoin: "Bitcoin",
            Otcusdt: "OTC USDT",
            Unionpay: "Unionpay"
        },

        pay: "Pay",
        zfbNotice: "注意：需按照订单金额使用本人支付宝账户进行扫码支付"
    },
    withdraw: {
        doWithdraw: "Withdraw",
        setRange: "Range",
        hint: "Fill in withdraw amount",

        notice_a: "Incorrect amount",
        notice_b: "Fill in withdraw amount",
        notice_c: "Over withdraw balance"
    },
    DelegateOrder: {
        a1: "Search condition",
        a2: "Keyword",
        a3: "Email or phone",
        a4: "Select",
        a5: "Symbol",
        a6: "Name or code",
        a7: "Start date",
        a8: "End date",
        a9: "Extra",
        a10: "Including sub",
        a11: "Pending order type",
        a12: "Open pending",
        a13: "Close pending",
        a14: "Locked",
        a15: "Group",
        a16: "Select group",

        a17: "Market type",
        a18: "Select market type",
        a19: "Stocks",
        a20: "Indices",
        a21: "Futures",
        a22: "Submit",

        b1: "Statistics",
        b2: "Client",
        b3: "Premium",
        b4: "Notional sum",
        b5: "List",
        b6: "OTC option",
        b7: "Exchange option",
        b8: "Cryptocurrenciey",

        c1: "Confirm",
        c2: "Detail",
        c3: "Code",
        c4: "Name",
        c5: "Premium ratio",
        c6: "Notional sum",
        c7: "Xxpiry",
        c8: "Trade method",
        c9: "Reference price",

        c11: "Order ID",
        c12: "Open price",
        c13: "Size",
        c14: "Price",
        c15: "Time",
        c16: "Reject",
        c17: "Confirm",
        c18: "Cancel",
        c19: "Size",
        c20: "Size",

        c21: "Confirm",
        c22: "Detail",
        c23: "Select",
        c24: "Save",
        c25: "Cancel",
        c26: "Pending",
        c27: "Price",
        c28: "Size",

        d1: "Pending",
        d2: "Notional sum",
        d3: "Turnover",
        d4: "Option type",
        d5: "Direction",
        d6: "Notional sum",
        d7: "Commission",
        d8: "Incomplete"
    },
    BitcoinTrading: {
        positionAction: {
            a1: "Modify ",
            a2: "Close ",
            a3: "Cancel",
            a4: "Take profit",
            a5: "Stop lose",
            a6: "Confirm",
            a7: "Close"
        },
        a1: "Trade",
        a2: "Market depth",

        b1: "High",
        b2: "Low",
        b3: "Vol",
        b4: "Open",
        b5: "Close",
        b6: "Turnover",
        b7: "Open interest",
        b8: "Bid",
        b9: "Ask",
        b10: "Open interest CHG",

        c1: "Equity",
        c2: "Margin",
        c3: "Free margin",
        c4: "Profit",
        c5: "Safety",

        d1: "Size",
        d2: "Lot",
        d3: "Market",
        d4: "Rival",
        d5: "Price",

        d6: "Open size",
        d7: "Close size",
        d8: "Margin per lot",
        d9: "Price",
        d10: "Buy",
        d11: "Sell",
        d12: "Close",
        d13: "Login",
        d14: "SignIn",

        e1: "Open",
        e2: "Pending",
        e3: "History",

        e4: "Name",
        e5: "Type",
        e6: "Size",
        e7: "Price",
        e8: "Time",
        e9: "Commission",
        e10: "Swap",
        e11: "Profit",
        e12: "Operate",
        e13: "Close",
        e14: "Cancel",

        e15: "Price",
        e16: "Time",

        ee15: "Price",
        ee16: "Time",

        e17: "Market depth",
        e18: "Buy",
        e19: "Sell",
        e20: "Price",
        e21: "Time",

        f1: "Buy",
        f2: "Sell"
    }
};
export default en;


// WEBPACK FOOTER //
// ./src/i18n/config/en.js